export const TRIAL_EXPIRED = 'trial_expired';
export const PENDING_CANCELLATION = 'pending_cancellation';
export const PAYMENT_ISSUE = 'payment_issue';
export const CANCELLED = 'cancelled';
export const NONE = 'none';
